import React from 'react';
import { salesDepartmentData } from '../footerContent';
import {
    DepartmentHeader, EmployeeCarouselItem, EmployeesCarousel,
    EmployeesContainer, StyledContact,
} from './ContactStyles';
import Employee from './Employee/Employee';

const Contact = ({ deparmentName, employees }) => (
    <StyledContact>
        <DepartmentHeader>{deparmentName}</DepartmentHeader>
        <EmployeesContainer numberOfEmployees={employees.length}>
            {employees.map((employee) => (
                <Employee
                    key={employee.name}
                    employee={employee}
                    enableExtraStyles={deparmentName === salesDepartmentData.name}
                />
            ))}
        </EmployeesContainer>
        <EmployeesCarousel indicators={false}>
            {employees.map((employee) => (
                <EmployeeCarouselItem key={employee.name}>
                    <Employee
                        employee={employee}
                        enableExtraStyles={deparmentName === salesDepartmentData.name}
                    />
                </EmployeeCarouselItem>
            ))}
        </EmployeesCarousel>
    </StyledContact>
);

export default Contact;
